var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    group = _require$doc$builders.group,
    line = _require$doc$builders.line,
    concat = _require$doc$builders.concat,
    indent = _require$doc$builders.indent;

module.exports = {
  match: function match(op) {
    return ['=', '|=', '^=', '&=', '<<=', '>>=', '+=', '-=', '*=', '/=', '%='].includes(op);
  },
  print: function print(node, path, _print) {
    return concat([path.call(_print, 'left'), ' ', node.operator, node.right.type === 'BinaryOperation' ? group(indent(concat([line, path.call(_print, 'right')]))) : concat([' ', path.call(_print, 'right')])]);
  }
};